import { createAction, emptyProps, props } from '@ngrx/store';
import { IOntapTVPendingConnection } from 'app/models/ontapTVPendingConnections';

export const loadItem = createAction('[TapTv Advanced List Page] Load OnTapTvPendingConnection', props<{ id: string }>());
export const loadItemSuccess = createAction('[OnTap Advanced API] Load OnTapTvPendingConnection Success', props<{ item: IOntapTVPendingConnection }>());
export const loadItemFailure = createAction('[OnTap Advanced API] Load OnTapTvPendingConnection Failure', props<{ error: any }>());

export const updateConnectionStatus = createAction('[TapTv Advanced Page] Update OnTapTvPendingConnection Connection Status', props<{ id: string, barId: string }>());
export const updateConnectionStatusSuccess = createAction('[TapTv Advanced API] Update OnTapTvPendingConnection Connection Status Success', emptyProps);
export const updateConnectionStatusFailure = createAction('[TapTv Advanced API] Update OnTapTvPendingConnection Connection Status Failure', props<{ error: any }>());



